import { __ } from "@wordpress/i18n";
(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    var ts = escapeRegExp(saphaliSettingsPrivatBank.ts);
    var $partforclient = {
      declOfNum: function (number, titles) {
        var cases = [2, 0, 1, 1, 1, 2];
        return (
          number +
          " " +
          titles[
            number % 100 > 4 && number % 100 < 20
              ? 2
              : cases[number % 10 < 5 ? number % 10 : 5]
          ]
        );
      },
      price: function (number) {
        var $t = $("tr.order-total strong")
          .text()
          .replace(/\s/, "")
          .replace(/\'/, "")
          .replace(new RegExp(ts, "g"), "")
          .match(/\d+,\d+\.\d+/gi)
          ? $("tr.order-total strong")
              .text()
              .replace(/\s/, "")
              .replace(/\'|,/, "")
              .replace(new RegExp(ts, "g"), "")
              .match(/\d+\.\d+/gi)[0]
          : $("tr.order-total strong")
              .text()
              .replace(/\s/, "")
              .replace(/\'/, "")
              .replace(new RegExp(ts, "g"), "")
              .match(/\d+\.\d+/gi)
          ? $("tr.order-total strong")
              .text()
              .replace(/\s/, "")
              .replace(/\'/, "")
              .replace(new RegExp(ts, "g"), "")
              .match(/\d+\.\d+/gi)[0]
          : $("tr.order-total strong")
              .text()
              .replace(/\s/, "")
              .replace(/\'/, "")
              .match(/\d+,\d\d[^\d]/gi)
          ? $("tr.order-total strong")
              .text()
              .replace(/\s/, "")
              .replace(/\'/, "")
              .match(/\d+,\d+/gi)[0]
              .replace(",", ".")
          : $("tr.order-total strong")
              .text()
              .replace(/\s/, "")
              .replace(/\'/, "")
              .replace(new RegExp(ts, "g"), "")
              .match(/\d+/gi)
          ? $("tr.order-total strong")
              .text()
              .replace(/\s/, "")
              .replace(/\'/, "")
              .replace(new RegExp(ts, "g"), "")
              .match(/\d+/gi)[0]
          : 0;

        $t = $t
          ? $t
          : $("tr.order-total strong")
              .text()
              .replace(/\s/g, "")
              .replace(/\'/, "")
              .replace(/\./g, "")
              .match(/\d+/gi)
          ? $("tr.order-total strong")
              .text()
              .replace(/\s/g, "")
              .replace(/\'/, "")
              .replace(/\./g, "")
              .match(/\d+/gi)[0]
          : $t;

        var $s = saphaliSettingsPrivatBank.price_skelet.replace("&#8372;", "₴");
        // console.log($t);
        if (
          $("tr.order-total strong")
            .text()
            .replace(/\s/, "")
            .replace(/\'/, "")
            .replace(new RegExp(ts, "g"), "")
            .match(/\d+\.\d+/gi)
        )
          return $t
            ? " по " + $s.replace(/\d+\.\d+/i, Math.ceil($t / number))
            : "";
        else
          return $t ? " по " + $s.replace(/\d+/i, Math.ceil($t / number)) : "";
      },
    };

    var namec = saphaliSettingsPrivatBank.partsCountName;
    var merchantType = $(
      '.method_description_part select[name="merchantType"]'
    ).val();
    if (typeof merchantType != "undefined") {
      var max =
        typeof namec[merchantType] != "undefined"
          ? namec[merchantType]
          : $("input.partforclient").attr("max");
      if (max < 3) {
        $(".main_block_part").hide("slow");
      } else $(".main_block_part").show("slow");
    }
    $("body").on(
      "change",
      '.method_description_part select[name="merchantType"]',
      function () {
        var pice =
          typeof namec[$(this).val()] != "undefined"
            ? namec[$(this).val()]
            : $("input.partforclient").val();
        $("input.partforclient").val(pice).trigger('change');
        var max =
          typeof namec[$(this).val()] != "undefined" &&
          $("input.partforclient").attr("max") != namec[$(this).val()]
            ? namec[$(this).val()]
            : $("input.partforclient").attr("max");
        $("input.partforclient").attr("max", max);
        $("span.partforclient_max").text(
          "(максимально " +
            $partforclient.declOfNum(max, [
              __("платеж", "themewoocommerce-pr_join"),
              __("платежа", "themewoocommerce-pr_join"),
              __("платежей", "themewoocommerce-pr_join"),
            ]) +
            ")"
        );
        if (max < 3) {
          $(".main_block_part").hide("slow");
        } else $(".main_block_part").show("slow");
      }
    );
    $("body").on("updated_checkout", function () {
      merchantType = $(
        '.method_description_part select[name="merchantType"]'
      ).val();
      if (typeof merchantType != "undefined") {
        var max =
          typeof namec[merchantType] != "undefined"
            ? namec[merchantType]
            : $("input.partforclient").attr("max");
        if (max < 3) {
          $(".main_block_part").hide("slow");
        } else $(".main_block_part").show("slow");
      }
    });
    $("body").on("keyup", "input.partforclient", function () {
      if (parseInt($(this).val(), 10) > parseInt($(this).attr("max"), 10))
        $(this).val($(this).attr("max")).change();
    });
    $("body").on("blur", "input.partforclient", function () {
      if (parseInt($(this).val(), 10) < 2) $(this).val(2).trigger("change");
    });
    $("body").on("change", "input.partforclient", function () {
      if (parseInt($(this).val(), 10) < 2) return false;
      $("span.partforclient_text").html(
        $partforclient.declOfNum($(this).val(), [
          __("платеж", "themewoocommerce-pr_join"),
          __("платежа", "themewoocommerce-pr_join"),
          __("платежей", "themewoocommerce-pr_join"),
        ]) +
          $partforclient.price($(this).val()) +
          __(" + % по кредиту", "themewoocommerce-pr_join")
      );
    });
  });
})(jQuery);
